<div class="contractor-cont">
  <div class="contractor-heading">
    {{ 'onboarding.sellCSB.title' | translate }}
  </div>
  <div class="contractor-desc">
    {{ 'onboarding.sellCSB.description' | translate }}
  </div>

  <form [formGroup]="csbForm" id="csbForm" name="csbForm">
    <div class="workwithNmo">
      <label>{{ 'onboarding.sellCSB.workingWithNmo' | translate }}</label>
    </div>
    <div>
      <mat-radio-group
        aria-label="Select an option"
        formControlName="workwithNmo"
        (change)="workwithNmoChanged($event.value)"
      >
        <mat-radio-button [value]="true"> Yes </mat-radio-button>
        <mat-radio-button [value]="false"> No</mat-radio-button>
      </mat-radio-group>
    </div>

    <ng-container *ngIf="csbForm.get('workwithNmo')?.value === true">
      <div class="contactNmo">
        <label> {{ 'onboarding.sellCSB.contactNmo' | translate }}</label>
      </div>
    </ng-container>

    <ng-container *ngIf="csbForm.get('workwithNmo')?.value === false">
      <div class="State">
        <label>{{ 'onboarding.sellCSB.producerState' | translate }}</label>
      </div>

      <div>
        <mat-form-field appearance="outline" class="input-work-state">
          <mat-select
            placeholder="Select"
            disableOptionCentering
            matInput
            [ngModel]
            state="state"
            formControlName="workingState"
            required
          >
            <mat-option [value]="'global.select' | translate" [disabled]="true">
              {{ 'global.select' | translate }}
            </mat-option>

            <mat-option *ngFor="let country of countries" [value]="country">
              {{ country }}
            </mat-option>
          </mat-select>
          <mat-error
            ><div
              class="input-error"
              *ngIf="csbForm?.get('workingState')?.errors?.['required']"
            >
              <cigna-icon
                type="exclamation-triangle"
                class="alert-icon"
              ></cigna-icon>
              {{ 'global.required' | translate }}
            </div>
          </mat-error>
        </mat-form-field>
      </div>
    </ng-container>

    <div class="btns">
      <button
        type="submit"
        mat-raised-button
        cg-mat-btn-type="primary"
        [disabled]="
          (csbForm.invalid && csbForm.get('workwithNmo')?.value === false) ||
          isInitialState
        "
        class="ls-button-fill"
        data-test-id="btn-submit"
        (click)="onContinue()"
      >
        {{ 'global.continue' | translate }}
      </button>

      <span
        mat-raised-button
        mat-button
        class="cancel-btn"
        data-test-id="btn-cancel"
        (click)="cancelForm()"
      >
        {{ 'global.cancel' | translate }}
      </span>
    </div>
  </form>
</div>
